import React from 'react';

const Hero = () => {
  return (
    <section className="hero" id="overview">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              uProject
              <span className="gradient-text">DIY Projects</span>
            </h1>
            <p className="hero-description">
              Dashboard đơn giản với ESP32 và màn hình LCD. Hiển thị các thông số cơ bản như tốc độ, 
              nhiệt độ engine, fuel level. Thiết kế tối giản, dễ sử dụng với khả năng cập nhật OTA.
            </p>
            <div className="hero-actions">
              <a href="#projects" className="btn btn-primary">
                <span className="material-icons">rocket_launch</span>
                Khám phá dự án
              </a>
              <a href="#contact" className="btn btn-secondary">
                <span className="material-icons">contact_mail</span>
                Liên hệ
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-animation">
              <div className="floating-cards">
                <div className="card small">
                  <span className="material-icons">dashboard</span>
                  <span>Dashboard</span>
                </div>
                <div className="card medium">
                  <span className="material-icons">memory</span>
                  <span>ESP32</span>
                </div>
                <div className="card large">
                  <span className="material-icons">code</span>
                  <span>Arduino</span>
                </div>
                <div className="card tiny bubble-1">
                  <span className="material-icons">wifi</span>
                </div>
                <div className="card tiny bubble-2">
                  <span className="material-icons">bluetooth</span>
                </div>
                <div className="card small bubble-3">
                  <span className="material-icons">sensors</span>
                  <span>IoT</span>
                </div>
                <div className="card medium bubble-4">
                  <span className="material-icons">speed</span>
                  <span>Real-time</span>
                </div>
                <div className="card tiny bubble-5">
                  <span className="material-icons">cloud_upload</span>
                </div>
                <div className="card small bubble-6">
                  <span className="material-icons">security</span>
                  <span>OTA</span>
                </div>
                <div className="card tiny bubble-7">
                  <span className="material-icons">developer_board</span>
                </div>
                <div className="card medium bubble-8">
                  <span className="material-icons">display_settings</span>
                  <span>HUD</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
